module.exports = __webpack_public_path__ + "img/flower-not.780e85b6.png";